import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import './ImpersonationCheckModal.css';

export interface SecurityInfo {
  name: string;
  browser_info: string;
  device_info: string;
  ip_address: string;
}

interface ImpersonationCheckModalProps {
  show: boolean;
  onHide: () => void;
  candidateSecurityInfo: SecurityInfo;
  respondentSecurityInfo: SecurityInfo;
}

const ImpersonationCheckModal: React.FC<ImpersonationCheckModalProps> = ({
  show,
  onHide,
  candidateSecurityInfo,
  respondentSecurityInfo,
}) => {

  const isEqual = (candidateValue: string, respondentValue: string): boolean => {
    if (!candidateValue || !respondentValue) return false;
    if (candidateValue === '不明' || respondentValue === '不明') return false;
    return candidateValue === respondentValue;
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      centered
      className="impersonation-check-modal"
      backdrop="static"  // Prevent close when clicking outside
      keyboard={false}   // Optional: Prevent closing with ESC key
    >
      <Modal.Header closeButton>
        <Modal.Title>なりすましチェック</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* 回答者情報セクション */}
        <div className="security-section candidate">
          <h5>回答者 {respondentSecurityInfo.name}さん</h5>
          <div className="security-item">
            <FontAwesomeIcon 
              icon={isEqual(candidateSecurityInfo.browser_info, respondentSecurityInfo.browser_info) ? faTimesCircle : faCheckCircle} 
              className={isEqual(candidateSecurityInfo.browser_info, respondentSecurityInfo.browser_info) ? "icon-match" : "icon-mismatch"} 
            />
            <span className="security-item-text">
              ブラウザ: {respondentSecurityInfo.browser_info || '不明'}
            </span>
          </div>
          <div className="security-item">
            <FontAwesomeIcon 
              icon={isEqual(candidateSecurityInfo.ip_address, respondentSecurityInfo.ip_address) ? faTimesCircle : faCheckCircle} 
              className={isEqual(candidateSecurityInfo.ip_address, respondentSecurityInfo.ip_address) ? "icon-match" : "icon-mismatch"} 
            />
            <span className="security-item-text">
              IPアドレス: {respondentSecurityInfo.ip_address || '不明'}
            </span>
          </div>
          <div className="security-item">
            <FontAwesomeIcon 
              icon={isEqual(candidateSecurityInfo.device_info, respondentSecurityInfo.device_info) ? faTimesCircle : faCheckCircle} 
              className={isEqual(candidateSecurityInfo.device_info, respondentSecurityInfo.device_info) ? 
                          "icon-match" : "icon-mismatch"} 
            />
            <span className="security-item-text">
              端末: {respondentSecurityInfo.device_info || '不明'}
            </span>
          </div>
        </div>

        {/* 候補者情報セクション */}
        <div className="security-section respondent">
          <h5>候補者 {candidateSecurityInfo.name}さん</h5>
          <div className="security-item">
            <FontAwesomeIcon 
              icon={isEqual(candidateSecurityInfo.browser_info, respondentSecurityInfo.browser_info) ? faTimesCircle : faCheckCircle} 
              className={isEqual(candidateSecurityInfo.browser_info, respondentSecurityInfo.browser_info) ? "icon-match" : "icon-mismatch"} 
            />
            <span className="security-item-text">
              ブラウザ: {candidateSecurityInfo.browser_info || '不明'}
            </span>
          </div>
          <div className="security-item">
            <FontAwesomeIcon 
              icon={isEqual(candidateSecurityInfo.ip_address, respondentSecurityInfo.ip_address) ? faTimesCircle : faCheckCircle} 
              className={isEqual(candidateSecurityInfo.ip_address, respondentSecurityInfo.ip_address) ? "icon-match" : "icon-mismatch"} 
            />
            <span className="security-item-text">
              IPアドレス: {candidateSecurityInfo.ip_address || '不明'}
            </span>
          </div>
          <div className="security-item">
            <FontAwesomeIcon 
              icon={isEqual(candidateSecurityInfo.device_info, respondentSecurityInfo.device_info) ? faTimesCircle : faCheckCircle} 
              className={isEqual(candidateSecurityInfo.device_info, respondentSecurityInfo.device_info) ? "icon-match" : "icon-mismatch"} 
            />
            <span className="security-item-text">
              端末: {candidateSecurityInfo.device_info || '不明'}
            </span>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ImpersonationCheckModal;
